export enum ResourcePath {
	ApprovalRequests = 'approval_requests',
	Awards = 'awards',
	Bonus = 'bonuses/{id}',
	Bonuses = 'bonuses',
	BonusFeedMeta = 'bonus_feeds/filter_options',
	BonusFeed = 'bonus_feeds',
	BonusImages = 'bonus_images',
	BonusReports = 'bonus_reports',
	BonuslyUser = 'user',
	Bookmarks = 'bookmarks',
	CatalogItem = 'catalog_items/{id}',
	Company = 'companies/show',
	GIFs = 'gifs',
	Dimension = 'autocompletion/dimensions/{id}',
	Dimensions = 'autocompletion/dimensions',
	Hashtags = 'hashtags',
	Reaction = 'reactions/{id}',
	Reactions = 'reactions',
	Recipients = 'recipients',
	Rewards = 'rewards',
	Users = 'users',
	UsersAutocomplete = 'users/autocomplete',
	Leaderboard = 'leaderboards',
	User = 'users/show',
	FeedbackRequests = 'constructive_feedback/requests',
	FeedbackResponse = 'constructive_feedback/responses/{id}',
	BonusVideoFeeds = 'video_feed',
}
